export enum DocumentClass {
  UNKNOWN = '',
  RECIPE = 'recipe',
  ARTICLE = 'article',
  GUIDE = 'guide',
  HOW_TO = 'how_to',
  BUYING_GUIDE = 'buying_guide',
  COLLECTION = 'collection',
  COURSE = 'course',
  COOKBOOK = 'cookbook',
  BOOK = 'book',
  EPISODE = 'episode',
  EQUIPMENT_REVIEW = 'equipment_review',
  TASTE_TEST = 'taste_test',
  VIDEO = 'video',
  MAGAZINE = 'magazine',
  PAGE = 'page',
  PLAYLIST = 'playlist',
  FEATURE = 'feature',
  DOCUMENT = 'document',
}

export enum DocumentClassFormatted {
  UNKNOWN = '',
  RECIPE = 'Recipe',
  ARTICLE = 'Article',
  GUIDE = 'Guide',
  HOW_TO = 'How To',
  BUYING_GUIDE = 'Buying Guide',
  COLLECTION = 'Collection',
  COURSE = 'Course',
  COOKBOOK = 'Cookbook',
  BOOK = 'Book',
  EPISODE = 'Episode',
  EQUIPMENT_REVIEW = 'Equipment Review',
  TASTE_TEST = 'Taste Test',
  VIDEO = 'Video',
  MAGAZINE = 'Magazine',
  PAGE = 'Page',
  PLAYLIST = 'Playlist',
  FEATURE = 'Feature',
  DOCUMENT = 'Document',
}

/**
 * Maps a `DocumentClass` value to its display label. Derived from the member
 * keys shared by both enums, so `DocumentClass` and `DocumentClassFormatted`
 * must be kept in sync — adding a member to one without the other yields
 * `undefined` for that class.
 */
export const documentClassToFormatted = Object.fromEntries(
  Object.entries(DocumentClass).map(([key, value]) => [
    value,
    DocumentClassFormatted[key as keyof typeof DocumentClassFormatted],
  ]),
) as Record<DocumentClass, DocumentClassFormatted>;

/**
 * Resolves an arbitrary resource type string to its display label. Falls back
 * to `UNKNOWN` (an empty string) for unmapped values so callers can rely on the
 * downstream `formatted || raw` fallbacks rather than rendering `undefined`.
 */
export function getDocumentClassFormatted(
  resourceType: string,
): DocumentClassFormatted {
  return (
    documentClassToFormatted[resourceType as DocumentClass] ??
    DocumentClassFormatted.UNKNOWN
  );
}
